import {
  DESCRIPTION_LABEL,
  LEVEL_LABEL,
} from "../../../../../../../constants/Dictionary";
import {
  ManagementTable,
  ManagementTableHeader,
} from "../../../../../Components/Table/ManagementTable";
import { SoftSkillsLevelConfigItem } from "../../../../../../../types/api/configurations.type";
import { FieldValues } from "react-hook-form";
import { compareDataGeneric } from "../../../../../../../utils/comparing.utils";
import {
  useManageSkillLevels,
  useUpdateManageSkillLevels,
} from "../../../../../../../hooks/management/CmSheet/SoftSkills/useManagementLevels.hooks";

type ManageLevelsProps = {
  toggleFilters: (x: boolean) => void;
  configYear: number;
};

export const ManageLevels = ({
  toggleFilters,
  configYear,
}: ManageLevelsProps) => {
  const { data, isFetching } = useManageSkillLevels(configYear);
  const { mutate: updateManageSkillLevels, isPending: isUpdatingSkillsLevels } =
    useUpdateManageSkillLevels();

  const levelsColumns: ManagementTableHeader[] = [
    {
      key: "name",
      label: LEVEL_LABEL,
      width: 40,
      type: "text",
    },
    {
      key: "description",
      label: DESCRIPTION_LABEL,
      width: 60,
      type: "text",
    },
  ];

  const onSave = async (formData: FieldValues) => {
    const compareData = (formData.items as SoftSkillsLevelConfigItem[]).map(
      (item, index) => ({
        ...item,
        position: index + 1,
      }),
    );
    const result = compareDataGeneric<SoftSkillsLevelConfigItem>(
      data!,
      compareData,
    );
    updateManageSkillLevels(result);
  };

  return (
    <ManagementTable<SoftSkillsLevelConfigItem>
      data={data ?? []}
      headers={levelsColumns}
      itemLabel={LEVEL_LABEL}
      draggableRows={true}
      keyItem={"name"}
      toggleFilters={toggleFilters}
      onSave={onSave}
      loading={isFetching || isUpdatingSkillsLevels}
    />
  );
};
